import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=38e1b9b0&scoped=true"
import script from "./top-bar.vue?vue&type=script&lang=js"
export * from "./top-bar.vue?vue&type=script&lang=js"
import style0 from "./top-bar.vue?vue&type=style&index=0&id=38e1b9b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1b9b0",
  null
  
)

export default component.exports